import api from './api.js';
import axios from 'axios'
import { TASK_V1_POST_CASES_ADD, TOKEN_LEGAL365, MAILS_SEND_CLIENT } from '../config.js'
import { getConsultantIdentifier } from '../Redux/UsersDucks.js'
import ErrorService from './errorService.js';
import Swal from 'sweetalert2';
import Cookies from 'universal-cookie'

export const FiniquitoService = {
    ListCausas: async (contractId) => {
        try {
            const response = await ErrorService.withTimeout(
                api.get('/Finiquito/V2/ListCausas/' + contractId)
            );
            console.log(response.data)
            return response.data;

        } catch (error) {
            // Manejar errores
            ErrorService.handleApiError('Error al iniciar la inyección:', error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'No se pudo realizar la inyección. Verifica los datos e inténtalo nuevamente.',
                confirmButtonText: 'Aceptar',
            });
            throw error;
        }
    },
    ListTemplateFiniquito: async (lineId) => {
        try {
            const response = await ErrorService.withTimeout(
                api.get('/Finiquito/V2/ListTemplateFiniquito?lineId=' + lineId)
            );
            return response.data;

        } catch (error) {
            // Manejar errores
            ErrorService.handleApiError('Error al iniciar la inyección:', error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'No se pudo realizar la inyección. Verifica los datos e inténtalo nuevamente.',
                confirmButtonText: 'Aceptar',
            });
            throw error;
        }
    },
    StartFiniquito: async (data) => {
        try {
            const consultantIdentifier = getConsultantIdentifier()
            if (!consultantIdentifier) {
                throw new Error('Consultor. Se debe de ingresar en el sistema es requerido su rut.');
            }
            data.CreateBy = consultantIdentifier;

            const cookies = new Cookies()
            const response = await ErrorService.withTimeout(
                api.post('/Finiquito/V2/FiniquitarContrato', data, { headers: { 'Authorization': `Bearer ${cookies.get('tokenGcc')}` } })
            );
            return response.data;

        } catch (error) {
            // Manejar errores
            ErrorService.handleApiError('Error al iniciar la inyección:', error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'No se pudo realizar el finiquito. Comuniquese a tecnologia@grupodefensa.cl .',
                confirmButtonText: 'Aceptar',
            });
            throw error;
        }
    },
    FiniquitoContrato: async (contractId) => {
        try {
            const response = await ErrorService.withTimeout(
                api.get('/Finiquito/V2/FiniquitoContrato?contractId=' + contractId)
            );
            return response.data;

        } catch (error) {
            // Manejar errores
            ErrorService.handleApiError('Error al iniciar la inyección:', error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'No se pudo realizar la inyección. Verifica los datos e inténtalo nuevamente.',
                confirmButtonText: 'Aceptar',
            });
            throw error;
        }
    },
    CuotasPendientes: async (rut, codCtto) => {
        try {
            codCtto = codCtto == null ? "" : '&codCtto=' + codCtto
            const response = await ErrorService.withTimeout(
                api.get('/Manager/ObtenerCuotasPendientes?rut=' + rut + codCtto)
            );
            return response.data;

        } catch (error) {
            // Manejar errores
            ErrorService.handleApiError('Error al iniciar la inyección:', error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'No se pudo realizar la inyección. Verifica los datos e inténtalo nuevamente.',
                confirmButtonText: 'Aceptar',
            });
            throw error;
        }
    },
    UnificarContrato: async (data) => {
        try {
            const consultantIdentifier = getConsultantIdentifier()
            if (!consultantIdentifier) {
                throw new Error('Consultor. Se debe de ingresar en el sistema es requerido su rut.');
            }
            data.CreatedBy = consultantIdentifier;
            const response = await ErrorService.withTimeout(
                api.post('/Unificacion/UnificarContrato', data)
            );
            return response.data;

        } catch (error) {
            // Manejar errores
            ErrorService.handleApiError('Error al iniciar la inyección:', error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'No se pudo realizar la inyección. Verifica los datos e inténtalo nuevamente.',
                confirmButtonText: 'Aceptar',
            });
            throw error;
        }
    }
};

export default FiniquitoService;